module.exports = __webpack_public_path__ + "img/media-17.6ae46590.png";